import { render, staticRenderFns } from "./note.vue?vue&type=template&id=621064a3&scoped=true&"
import script from "./note.vue?vue&type=script&lang=js&"
export * from "./note.vue?vue&type=script&lang=js&"
import style0 from "./note.vue?vue&type=style&index=0&id=621064a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621064a3",
  null
  
)

/* custom blocks */
import block0 from "./note.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

component.options.__file = "note.vue"
export default component.exports